import { Alert, Col, DatePicker, Form, List, Row, Space, Input } from 'antd';
import LocaleContext from 'locales';
import UserSearch from 'components/UserSearch';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { OwnDesktops, RequestInfo, TimePreset } from './components';
import FormItemApprovalLine from './components/FormItemApprovalLine';

function DesktopReinstall(props) {
  const { id, type, form, isCreate, detailData, onFinishDetail, backConf } = props;
  const { locale } = useContext(LocaleContext);
  const [selectedVd, setSelectedVd] = React.useState([]);
  const [userSearchNamePath, setUserSearchNamePath] = useState(undefined); // UserSearch를 설정할 폼의 네임 패스

  useEffect(() => {
    if (!id) {
      form.resetFields();

      const applicant = localStorage.getItem('userId');
      form.setFieldsValue({
        applicant,
        type: 'approval.types.reset-vd',
      });
      return;
    }

    if (detailData) {
      let approveDate = detailData?.approveDate;
      if (approveDate && !moment.isMoment(approveDate)) {
        approveDate = moment(new Date(approveDate));
      }

      form.setFieldsValue({
        ...detailData,
        approveDate,
        applyDate: moment(detailData.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });
    }
  }, [id, detailData]);
  // 사용자 선택되었을 때
  const onUserSearchSelected = (selectedUser) => {
    // 선택 취소면 아무것도 안한다.
    if (!selectedUser) {
      setUserSearchNamePath(undefined);
      return;
    }
    const result = { [userSearchNamePath]: selectedUser.sAMAccountName };
    form.setFieldsValue(result);
    setUserSearchNamePath(undefined);
  };
  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 19 }}
      onFinish={async ({ approveDate, ...fields }) => {
        const payload = {
          ...fields,
          contents: selectedVd,
          approveDate: approveDate?.format('YYYY-MM-DD HH:mm') || approveDate,
        };
        onFinishDetail(payload);
      }}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Alert
            showIcon
            type="warning"
            message={
              <List
                size="small"
                split={false}
                dataSource={[locale.resource['txt.os-reinstall-msg']]}
                renderItem={(item) => <List.Item style={{ padding: 4 }}>{item}</List.Item>}
              />
            }
          />
        </Col>
        <Col span={24}>
          <RequestInfo readOnly={!isCreate} />
          <Form.Item label={locale.resource['txt.approval-type']} name="type" required>
            {locale.resource['txt.vd-reset']}
          </Form.Item>
          <Form.Item label={locale.resource['txt.user-and-id']} required>
            <Row gutter={[0, 4]}>
              <Col span={24}>
                <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Form.Item
                    noStyle
                    name="user"
                    rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
                  >
                    <Input.Search
                      readOnly
                      disabled={!isCreate}
                      onSearch={() => setUserSearchNamePath(['user'])}
                    />
                  </Form.Item>
                  <UserSearch visible={userSearchNamePath} onSelected={onUserSearchSelected} />
                </Space>
              </Col>
            </Row>
          </Form.Item>
          <Form.Item
            label={locale.resource['txt.reinstallation']}
            name="contents"
            valuePropName="contents"
            required
          >
            <OwnDesktops
              readOnly={!isCreate}
              user={detailData?.user || form.getFieldValue('user')}
              apprType={type}
              onSelect={(record) => {
                setSelectedVd(record);
              }}
              requestId={id}
            />
          </Form.Item>
          <Form.Item
            label={locale.resource['txt.execution-date']}
            name="approveDate"
            extra={locale.resource['txt.excution-date-msg']}
            rules={[
              () => ({
                validator(_, value) {
                  if (value > moment() || !value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(locale.resource['txt.excution-date-val']));
                },
              }),
            ]}
            initialValue={null} // #193685
          >
            <DatePicker
              showTime={{
                defaultValue: moment('00:00', 'HH:mm'),
                format: 'HH:mm',
              }}
              inputReadOnly={1}
              disabled={!isCreate}
              placeholder=""
              disabledDate={(date) => date && date < moment().startOf('day')}
              showNow={false}
              format="YYYY-MM-DD HH:mm"
              renderExtraFooter={() => (
                <TimePreset
                  onSelect={(time) => {
                    form.setFieldsValue({ approveDate: time });
                  }}
                />
              )}
            />
          </Form.Item>
          <FormItemApprovalLine isCreate={isCreate} form={form} backConf={backConf} type={type} />
        </Col>
      </Row>
    </Form>
  );
}

export default DesktopReinstall;
